export const SERVICE_NAME = process.env.REACT_APP_SERVICE_NAME;
export const REST_SERVER_URL = process.env.REACT_APP_REST_SERVER_URL;
export const WEBSOCKET_SERVER_URL = process.env.REACT_APP_WEBSOCKET_SERVER_URL;
export const WEBSOCKET_PATH = process.env.REACT_APP_WEBSOCKET_PATH;
export const WEBSOCKET_ACCESS_KEY = process.env.REACT_APP_WEBSOCKET_ACCESS_KEY;
export const STREAMING_SERVER_URL = process.env.REACT_APP_STREAMING_SERVER_URL;
